import WooCommerceCLIAPI from './WooCommerceCLIAPI';
import GravityFormsCLIAPI from './GravityFormsCLIAPI';
import TransferTestCLIAPI from './TransferTestCLIAPI';
import CventCLIAPI from './CventCLIAPI';
import sqlApp from './sql-app';

import { Fixtures } from '../types';

export const FIXTURES: Fixtures = {
  WooCommerceCLIAPI,
  App150499CLIAPI: WooCommerceCLIAPI, // Zapier’s internal dev app clone (production)
  App70879CLIAPI: WooCommerceCLIAPI, // WooCommerce’s dev app (production)
  App119177CLIAPI: WooCommerceCLIAPI, // Zapier’s internal dev app clone (staging)

  GravityFormsCLIAPI,
  App119267CLIAPI: GravityFormsCLIAPI, // Zapier's internal app clone (staging)

  CventCLIAPI,

  TransferTestCLIAPI, // Transfer Test App (staging, public)
  App147982CLIAPI: TransferTestCLIAPI, // Transfer Test App (production, invite-only)

  // SQL apps in both staging and production
  MySQLAPI: sqlApp,
  PostgreSQLAPI: sqlApp,
  MSSQLAPI: sqlApp,
};
